import React from "react";
import "./loader.css";

export default function Loader() {
  return (
    <div className="full-loader">
      <div className="spinner"></div>

      {/* <h1 className="typewriter-text">The Exam Time</h1> */}
    </div>
  );
}
